import { trpc } from '@/shared/api';

interface PaymentCheckoutQueryOptions {
  readonly enabled?: boolean;
}

/** 결제 정보(payments.getCheckout) — 결제 가능 여부·금액·주문명·고객 키. */
export const usePaymentCheckoutQuery = (
  orderId: string,
  options: PaymentCheckoutQueryOptions = {},
) =>
  trpc.payments.getCheckout.useQuery(
    { orderId },
    {
      enabled: options.enabled ?? true,
      // 결제 불가·주문 없음은 재시도해도 같다.
      retry: false,
    },
  );
